<app-smart-input-entity
  fieldLabel="name"
  [control]="control()"
  [handler]="groupPickerHandler()"
  [placeholder]="placeholder()"
  [resetValue]="resetValue()">
  <ng-template
    let-item="item"
    appTemplate>
    @if (cast(item); as group) {
      <app-avatar
        [showName]="true"
        [name]="group.groupName"
        [icon]="'people'"></app-avatar>
    }
  </ng-template>
</app-smart-input-entity>
